import axios from "@/config/axios";
export default {
    //全球签详情
    gs_details: data => axios.post("http://www.softlinkonline.cn/index/gs_details", data),
    // 小黑板
    global_signature_title_list: data => axios.post("http://www.softlinkonline.cn/index/global_signature_title_list", data),

    //评论列表
    global_comment_list: data => axios.post("http://www.softlinkonline.cn/index/global_comment_list", data),
    //提交评论
    add_comment: data => axios.post("http://www.softlinkonline.cn/index/add_comment", data),
};